// 日時のフォーマット
const DATE_FORMAT = 'YYYY/MM/DD (ddd)'
// 時刻のフォーマット
const TIME_FORMAT = 'HH:mm'

/**
 * スケジュールの期間のフォーマットクラス
 */
class SchedulePeriodFormatter {
  /**
   * コンストラクタ
   *
   * @param {String} [allDayText=''] 終日として表示するテキスト
   * @param {String} [dateFormat='YYYY/MM/DD (ddd)'] 日付フォーマット文字列
   * @param {String} [timeFormat='HH:mm'] 時刻フォーマット文字列
   */
  constructor({
    allDayText = '',
    dateFormat = DATE_FORMAT,
    timeFormat = TIME_FORMAT,
  }) {
    this.allDayText = allDayText
    this.dateFormat = dateFormat
    this.timeFormat = timeFormat
  }

  /**
   * フォーマットする
   *
   * @param {Schedule} schedule スケジュール
   * @returns {String} フォーマット後期間文字列
   */
  format(schedule) {
    if (!schedule.startAt || !schedule.endAt) {
      return ''
    }

    // 終日
    if (schedule.isAllDay) {
      return `${schedule.startAt.format(this.dateFormat)} ${this.allDayText}`
    }

    const startFormat = `${this.dateFormat} ${this.timeFormat}`
    // 開始と終了の日付が同じ場合は終了の日付は省略
    const endFormat = schedule.startAt.isSame(schedule.endAt, 'day')
      ? this.timeFormat
      : startFormat
    return `${schedule.startAt.format(startFormat)} - ${schedule.endAt.format(
      endFormat
    )}`
  }
}

export default SchedulePeriodFormatter
